import { render, staticRenderFns } from "./delete-all-media.vue?vue&type=template&id=b2b2a80e&"
import script from "./delete-all-media.vue?vue&type=script&lang=js&"
export * from "./delete-all-media.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports